// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// import Layout from './views/Layout'
import App from './App';
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from './router';
import ElementUI from 'element-ui';
import { translate, translateCapital } from '@/utils/translate';
// import locale from 'element-ui/lib/locale/lang/el'

import i18n from './lang'; // Internationalization
import store from './store';

// import 'element-ui/lib/theme-chalk/index.css'
import './assets/scss/element-variables.scss';
// import './store'
import './assets/scss/main.scss';
// var lang = localStorage.getItem('appLanguage')
// if (lang === 'gr') { lang = 'el' }
// moment.locale(lang)
Vue.config.productionTip = false;
Vue.use(
  ElementUI,
  {
    size: 'medium', // set element-ui default size
    i18n: (key, value) => i18n.t(key, value)
  },
  VueAxios,
  axios
);
Vue.prototype.$http = axios;
Vue.prototype.$translation = translate;
Vue.prototype.$translationCapital = translateCapital;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js